<template>
    <div class="advanced-config">
        <p
            :class="`advanced-config-activator ${isOpen ? 'open' : 'closed'}`"
            @click="openConfigs"
        >
            {{ $t("message.generics.message.advancedSettings") }}
        </p>

        <div v-if="isOpen" :class="`advanced-config-fields`">
            <div
                class="advanced-config-fields-field advanced-config-fields-integration"
            >
                <template
                    v-if="isEdit && canUseMarketingModule && !isBillingFormType"
                >
                    <checkbox
                        class="checkbox-default"
                        :value="value.isValidatePhoneNumber"
                        :label="
                            $t(
                                'message.loginPersonalize.message.activatePhoneValidation'
                            )
                        "
                        hide-details
                        @input="emitInput($event, 'isValidatePhoneNumber')"
                    />

                    <checkbox
                        class="checkbox-default"
                        :value="value.isValidateEmail"
                        :label="
                            $t(
                                'message.loginPersonalize.message.activateEmailValidation'
                            )
                        "
                        hide-details
                        @input="emitInput($event, 'isValidateEmail')"
                    />
                </template>

                <text-field
                    label="VLAN"
                    name="VLAN"
                    type="number"
                    :help="$t('message.loginPersonalize.message.vlanTooltip')"
                    :value="value.vlan"
                    :error-messages="errors.collect('VLAN')"
                    @blur="emitInput($event.target.value, 'vlan')"
                >
                </text-field>

                <SSIDFilter
                    :value="value.ssidFilter"
                    :is-all-selected="value.allSsidSelected"
                    @input="emitInput($event, 'ssidFilter')"
                    @update-all-selected="emitInput($event, 'allSsidSelected')"
                />
            </div>
        </div>

        <p
            v-if="isOpen"
            :class="`advanced-config-activator advanced-config-activator_close`"
            @click="closeConfigs"
        >
            {{ $t("message.campaigns.message.seeLess") }}
        </p>
    </div>
</template>
<script>
import vModel from "@mixins/v-model";
import { cloneDeep } from "lodash";
import Checkbox from "../../../../../Checkbox.vue";
import TextField from "@components/form/TextField.vue";
import SSIDFilter from "../../../../ssid/SSIDFilter.vue";

export default {
    components: {
        Checkbox,
        TextField,
        SSIDFilter,
    },
    data() {
        return {
            isOpen: false,
        };
    },
    props: {
        value: {
            type: Object,
        },
        isEdit: {
            type: Boolean,
            required: true,
        },
        type: {
            type: String,
            required: true,
        },
    },

    computed: {
        permissions() {
            return this.$store.state.users.user.permissions;
        },
        user() {
            return this.$store.state.users.user;
        },
        canUseMarketingModule() {
            return this.user.permissions.find(
                (x) => x === "USE_MARKETING_MODULE"
            );
        },
        isBillingFormType() {
            return this.type === "BILLING";
        },
    },
    methods: {
        openConfigs() {
            this.isOpen = true;
        },
        closeConfigs() {
            this.isOpen = false;
        },
        emitInput(val, key) {
            const value = cloneDeep(this.value);
            value[key] = val;
            this.$emit("input", value);
        },
    },

    mixins: [vModel],
};
</script>
<style lang="scss" scoped>
@import "~@variables";
.advanced-config {
    width: 100%;
    .advanced-config-activator {
        color: $selected;
        text-decoration: underline;
        cursor: pointer;
        font-weight: 500;
        text-align: center;
        &.advanced-config-activator_close {
            font-size: 14px;
        }
        &.open {
            cursor: default;
            color: $color-muted;
            text-decoration: none;
        }
    }
    .advanced-config-fields {
        /* display: flex;
    justify-content: center; */
        margin: 0 auto;
        width: 100%;
        margin-bottom: 15px;
        .v-input {
            display: flex;
            justify-content: center;
            font-weight: 500;
            font-size: 14px !important;
        }
    }
}
</style>
